import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@ensemble/components';
import { register } from 'swiper/element/bundle';

// Configure Ensemble icons path before importing components
(window as any).EnsembleConfig = {
  icons: {
    path: '/assets/ensemble-icons',
    format: 'svg'
  }
};

register();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
